module.exports = __webpack_public_path__ + "static/img/context_img.9ba4cf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/context_img.png
// module id = 170
// module chunks = 1